import { IFRAME_CONTEXT_STORAGE_KEY } from '@constants/iframe';
import type { InstrumentQueryParams } from '@utils/queryParams';

const isCompleteInstrument = (value: Partial<InstrumentQueryParams> | null): value is InstrumentQueryParams =>
  Boolean(value?.ticker?.trim() && value?.mkt?.trim());

const getStorage = (): Storage | null => {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage;
  } catch {
    return null;
  }
};

export const getLastInstrumentContext = (): InstrumentQueryParams | null => {
  const storage = getStorage();
  if (!storage) return null;

  try {
    const raw = storage.getItem(IFRAME_CONTEXT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<InstrumentQueryParams>;
    if (!isCompleteInstrument(parsed)) return null;
    return {
      ticker: parsed.ticker.trim(),
      mkt: parsed.mkt.trim(),
    };
  } catch {
    return null;
  }
};

export const persistLastInstrumentContext = (instrument: InstrumentQueryParams): void => {
  if (!isCompleteInstrument(instrument)) return;

  const storage = getStorage();
  if (!storage) return;

  try {
    storage.setItem(
      IFRAME_CONTEXT_STORAGE_KEY,
      JSON.stringify({
        ticker: instrument.ticker.trim(),
        mkt: instrument.mkt.trim(),
      }),
    );
  } catch {
    // Browser privacy modes can reject localStorage; the URL fallback still works.
  }
};
